import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

function generateStripe(size = '1rem', color = 'rgba(255, 255, 255, 0.15)') {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${size} ${size}`,
  };
}

const Slider = defineSlotRecipe({
  slots: [
    'root',
    'label',
    'control',
    'track',
    'range',
    'markerGroup',
    'marker',
    'markerIndicator',
    'thumb',
  ],
  base: {
    // shows the current progress (variable width)
    range: {
      bg: 'podcastPurple500',
      borderRadius: '10px',
      border: 'none',
    },
    // background element (always 100% width)
    track: {
      bg: 'podcastShade200',
      border: 'none',
      borderRadius: '10px',
      boxShadow: 'none',
    },
    thumb: {
      display: 'none',
    },
  },
  variants: {
    visual: {
      loading: {
        range: {
          ...generateStripe('1rem', 'rgba(0,0,0,0.1)'),
          bg: 'podcastShade300',
        },
      },
      turquoise: {
        range: {
          bg: 'podcastBlue600',
        },
      },
      purple: {
        range: {
          bg: 'podcastPurple500',
        },
      },
      orange: {
        range: {
          bg: 'podcastOrange',
        },
      },
      grey: {
        range: {
          bg: 'podcastShade300',
        },
      },
      upload: {
        range: {
          height: '12px',
        },
        track: {
          maxWidth: '200px',
          height: '12px',
        },
      },
      miniPlayer: {
        range: {
          bg: 'podcastPurple500',
        },
        track: {
          background: 'white',
        },
      },
      disabled: {
        track: {
          background: colors.podcastShade100,
          opacity: '0.8',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'purple',
    // @ts-ignore chakra types say there is no variant but github source does
    variant: 'none',
  },
});

export default Slider;
